"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("../base");
const util_1 = require("../util");
class LiquidateModule extends base_1.TectonicSDKModule {
    async accountLiquidity(borrowerAddress) {
        // function getAccountLiquidity(address account) public view returns (uint, uint, uint) {
        const tCore = this.getTectonicCore();
        const [errorCode, liquidity, shortfall] = await tCore.getAccountLiquidity(borrowerAddress);
        return { errorCode: errorCode.toNumber(), liquidity, shortfall };
    }
    async checkLiquidateAllowed(tTokenBorrowed, tTokenCollateral, liquidator, borrower, repayAmount) {
        const tCore = this.getTectonicCore();
        const result = await tCore.callStatic.liquidateBorrowAllowed(tTokenBorrowed, tTokenCollateral, liquidator, borrower, repayAmount);
        return result.toNumber();
    }
    async liquidateBorrowErc20(tTokenBorrowed, tTokenCollateral, borrower, repayAmount) {
        const tToken = this.getContractByAddress(tTokenBorrowed);
        return (0, util_1.wrapSdkTransaction)(tToken.liquidateBorrow(borrower, repayAmount, tTokenCollateral));
    }
    async liquidateBorrowEther(tTokenBorrowed, tTokenCollateral, borrower, repayAmount) {
        const tToken = this.getContractByAddress(tTokenBorrowed);
        return (0, util_1.wrapSdkTransaction)(tToken.liquidateBorrow(borrower, tTokenCollateral, { value: repayAmount }));
    }
}
exports.default = LiquidateModule;
//# sourceMappingURL=liquidate.js.map